import { render, staticRenderFns } from "./record.vue?vue&type=template&id=1d8db6cc&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=1d8db6cc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8db6cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8db6cc')) {
      api.createRecord('1d8db6cc', component.options)
    } else {
      api.reload('1d8db6cc', component.options)
    }
    module.hot.accept("./record.vue?vue&type=template&id=1d8db6cc&scoped=true", function () {
      api.rerender('1d8db6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/withdraw/record.vue"
export default component.exports